import React, { useContext, useRef, useEffect } from 'react';
import { Overlay, Tooltip }              from 'react-bootstrap';
import { GraduationCap }                 from 'lucide-react';
import { TooltipContext }                from './TooltipContext';

const SRNABadge = () => {
  const { openId, setOpenId } = useContext(TooltipContext);
  const targetRef = useRef(null);
  const timerRef  = useRef(null);

  useEffect(() => () => clearTimeout(timerRef.current), []);

  const show = e => {
    e.stopPropagation();
    clearTimeout(timerRef.current);
    setOpenId('srna-badge');
    timerRef.current = setTimeout(() => {
      setOpenId(curr => curr === 'srna-badge' ? null : curr);
    }, 1200);
  };
  const hide = e => {
    e && e.stopPropagation();
    clearTimeout(timerRef.current);
    setOpenId(curr => curr === 'srna-badge' ? null : curr);
  };

  return (
    <>
      <span
        ref={targetRef}
        className="srna-badge"
        onClick={show}
        onTouchStart={show}
        onMouseEnter={show}
        onMouseLeave={hide}
      >
        <GraduationCap size={20} className="srna-icon" />
      </span>

      <Overlay
        target={targetRef.current}
        show={openId === 'srna-badge'}
        placement="top"
        transition={false}
        rootClose={true}
        onHide={hide}
      >
        <Tooltip id="tooltip-srna-badge">Student Registered Nurse Anesthetist (SRNA)</Tooltip>
      </Overlay>
    </>
  );
};

export default SRNABadge;
